import React from "react";
import { optimizeImageUrl } from "../../utils/images";

const GALLERY = [
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/56f682ca-6792-4beb-9592-5a739abdad46_rba1yy.jpg", alt: "Luxury perfume bottle" },
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/c441ac09-113b-432d-9c70-da19e18dc50e_jcx7qr.jpg", alt: "Fragrance lifestyle" },
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/24addfe5-e498-4f51-b993-dc225bb6ad67_ewitxq.jpg", alt: "Perfume collection" },
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/3e2f992a-5eb7-45a6-bd07-6726c229b333_v708up.jpg", alt: "Scent bottle close up" },
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/ecda9576-3a48-4989-b253-d0634a8c532b_tzsb4y.jpg", alt: "Perfume spray" },
  { src: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775554080/4779ae56-e07a-431e-a804-255043016404_q3ioyd.jpg", alt: "Luxury scent" },
];

const FALLBACK = optimizeImageUrl("https://images.unsplash.com/photo-1541643600914-78b084683702?w=500&q=80", { width: 900 });

function GalleryImage({ image, className = "" }) {
  return (
    <div className={`overflow-hidden rounded-sm group relative ${className}`}>
      <img
        src={optimizeImageUrl(image.src, { width: 900 })}
        alt={image.alt}
        loading="eager"
        fetchPriority="high"
        sizes="(min-width: 1280px) 30vw, (min-width: 768px) 45vw, 100vw"
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        onError={(event) => { event.currentTarget.src = FALLBACK; }}
      />
      <div className="absolute inset-0 bg-brand-dark/0 group-hover:bg-brand-dark/25 transition-colors duration-300" />
    </div>
  );
}

export default function Gallery() {
  return (
    <section className="py-24 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="section-label">The Aesthetic</span>
          <h2 className="section-title mt-2">A World of Scent</h2>
        </div>
        <div className="grid gap-3 md:grid-cols-[0.72fr_1fr] md:items-stretch md:h-[520px] lg:grid-cols-[0.58fr_1fr] lg:h-[580px] xl:grid-cols-[0.46fr_1fr] xl:h-[645px]">
          <GalleryImage image={GALLERY[0]} className="aspect-[4/5] sm:aspect-[5/6] md:h-full md:min-h-0 md:aspect-auto" />

          <div className="grid gap-3 md:h-full md:min-h-0 md:grid-rows-2">
            <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-[1.15fr_0.85fr] lg:grid-cols-[1.25fr_0.85fr] xl:grid-cols-[1.35fr_0.85fr] md:h-full md:min-h-0">
              {GALLERY.slice(1, 3).map((image) => (
                <GalleryImage key={image.src} image={image} className="aspect-[4/3] md:h-full md:min-h-0 md:aspect-auto" />
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:h-full md:min-h-0">
              {GALLERY.slice(3).map((image) => (
                <GalleryImage key={image.src} image={image} className="aspect-[4/3] md:h-full md:min-h-0 md:aspect-auto" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
